export var DataCondition;
(function (DataCondition) {
    /** @returns 0 */
    DataCondition[DataCondition["LOADING"] = 0] = "LOADING";
    /** @returns 1 */
    DataCondition[DataCondition["EMPTY"] = 1] = "EMPTY";
    /** @returns 2 */
    DataCondition[DataCondition["ERROR"] = 2] = "ERROR";
    /** @returns 3 */
    DataCondition[DataCondition["LOADED"] = 3] = "LOADED";
})(DataCondition || (DataCondition = {}));
//# sourceMappingURL=index.js.map